const combinedFaqData = {
  softwareDevelopment: [
    {
      question: "I want to outsource my software development project. How do I get started?",
      answer: "Contact us via website, email, or phone. We'll consult, provide an estimate and proposal, and then start development.",
    },
    {
      question: "What industries do you specialize in?",
      answer: "We specialize in Manufacturing/IoT, FinTech, eCommerce/Retail, Healthcare, and Telecommunications.",
    },
    {
      question: "Who owns the code?",
      answer: "You own 100% of the code and IP from the start. It's yours.",
    },
    {
      question: "Can I trust my information's confidentiality with your team?",
      answer: "Yes. All team members sign NDAs, and we use industry-standard data protection. We'll sign one before you share details.",
    },
    {
      question: "How long does it take to process my request and start cooperation?",
      answer: "We respond within 24-48 hours. Proposals are usually within 1-2 weeks, and cooperation can start within 2-4 weeks after approval.",
    },
  ],
  general: [
    {
      question: "What types of software development services do you offer?",
      answer: "We provide a wide range of services, including web development, mobile app development, custom software solutions, cloud-based applications, and software maintenance and support."
    },
    {
      question: "How long does it typically take to develop a software project?",
      answer: "The timeline varies depending on the project's complexity, scope, and requirements. A simple application may take 2-4 months, while more complex projects can take 6-12 months or longer."
    },
    {
      question: "Do you provide post-launch support for software projects?",
      answer: "Yes, we offer comprehensive post-launch support, including bug fixes, updates, performance optimization, and feature enhancements to ensure your software remains reliable and up-to-date."
    },
    {
      question: "What is your approach to project management?",
      answer: "We use agile methodologies, such as Scrum, to manage projects. This involves iterative development, regular client feedback, and transparent communication to deliver high-quality software on time."
    },
    {
      question: "Can you integrate third-party APIs into our software?",
      answer: "Absolutely, we have extensive experience integrating third-party APIs, such as payment gateways, social media platforms, and analytics tools, to enhance your software's functionality."
    }
  ]
};

export default combinedFaqData;